import { Component, ChangeDetectionStrategy } from "@angular/core";

/**
 * Decorative CSS bubble animation, used as a background effect by the side navbar.
 */
@Component({
  selector: "app-water-effect",
  templateUrl: "./water-effect.component.html",
  styleUrls: ["./water-effect.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class WaterEffectComponent {}
